import { forwardRef, ReactNode, useEffect, useRef, useState } from 'react';
import { useIsPresent } from 'motion/react';
import { VideoPlayerHandle } from 'src/components';
import * as S from './styles';

type VideoPanelProps = {
  src: string;
  autoPlay: boolean;
  rail?: ReactNode;
  onPlayButtonClick?: () => void;
  onEnded?: () => void;
};

export const VideoPanel = forwardRef<VideoPlayerHandle, VideoPanelProps>(
  ({ src, autoPlay, rail, onPlayButtonClick, onEnded }, ref) => {
    const panelRef = useRef<HTMLDivElement>(null);
    const isPresent = useIsPresent();
    const [playbackFraction, setPlaybackFraction] = useState(0);

    // Stops an outgoing card's video playing over the incoming one while it slides away
    useEffect(() => {
      if (!isPresent) {
        panelRef.current?.querySelectorAll('video').forEach(video => video.pause());
      }
    }, [isPresent]);

    return (
      <S.Panel ref={panelRef} data-testid="blob-video-panel">
        <S.Video
          ref={ref}
          src={src}
          autoPlay={autoPlay}
          mutedAutoplayFallback
          progressiveQuality
          playOnKeyboardShortcut
          onProgress={setPlaybackFraction}
          onPlayButtonClick={onPlayButtonClick}
          onEnded={onEnded}
        />
        {rail}
        <S.PlaybackProgress $fraction={playbackFraction} data-testid="blob-video-progress" />
      </S.Panel>
    );
  },
);

VideoPanel.displayName = 'VideoPanel';
